import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage if present (fallback to cookie auth)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fc_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatBRL(value) {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2 });
}

// Regex para "YYYY-MM-DD" (date-only, sem horário) — evita conversão UTC→BRT
// que subtraía 1 dia (bug reportado: dia 10 aparecia como dia 09).
const _DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

export function formatDateBR(iso) {
  if (!iso) return "—";
  try {
    // Se for date-only ("YYYY-MM-DD"), formata como data civil, sem timezone.
    const m = typeof iso === "string" ? iso.match(_DATE_ONLY_RE) : null;
    if (m) {
      return `${m[3]}/${m[2]}/${m[1]}`;
    }
    // datetime completo: mantém conversão para timezone local (America/Sao_Paulo).
    return new Date(iso).toLocaleDateString("pt-BR", {
      day: "2-digit", month: "2-digit", year: "numeric", timeZone: "America/Sao_Paulo",
    });
  } catch (_) { return "—"; }
}

export function formatDateTimeBR(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
      timeZone: "America/Sao_Paulo",
    });
  } catch (_) { return "—"; }
}

export function maskCPF(cpf) {
  if (!cpf) return "";
  const d = String(cpf).replace(/\D/g, "").slice(0, 11);
  return d
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1-$2");
}

export function maskPhone(v) {
  if (!v) return "";
  const d = String(v).replace(/\D/g, "").slice(0, 11);
  if (d.length <= 10) return d.replace(/^(\d{2})(\d{4})(\d)/, "($1) $2-$3");
  return d.replace(/^(\d{2})(\d{5})(\d)/, "($1) $2-$3");
}

export const STATUS_LABELS = {
  novo: "Novo",
  em_analise: "Em análise",
  pendente_documentacao: "Pendente documentação",
  aprovado: "Aprovado",
  aprovacao_parcial: "Aprovação parcial",
  contratado: "Contratado",
  pago: "Pago",
  negado: "Negado",
};

export const RISK_LABELS = {
  baixo: "Baixo",
  medio: "Médio",
  alto: "Alto",
  critico: "Crítico",
};

export const DOC_TYPE_LABELS = {
  documento_frente: "Documento (Frente)",
  documento_verso: "Documento (Verso)",
  selfie_documento: "Selfie com documento",
  comprovante_residencia: "Comprovante de residência",
  comprovante_renda: "Comprovante de renda",
  foto_fachada: "Foto da fachada",
  foto_interna: "Foto interna da casa",
  doc_adicional: "Documento adicional",
  contrato_assinado: "Contrato assinado",
  print_rede_social: "Print de rede social (Facebook/Instagram)",
};

export const REQUIRED_DOCS = [
  "documento_frente",
  "documento_verso",
  "selfie_documento",
  "comprovante_residencia",
  "comprovante_renda",
  "foto_fachada",
  "print_rede_social",
];

export const OPTIONAL_DOCS = ["foto_interna"];
